module.exports = __webpack_public_path__ + "images/Trivago-c4c0b4.png";